import { useRouter } from 'next/router';
import { rudderStackTrack } from './Track';
import Link from 'next/link';

export const TrackLink = ({action, href, children}) => {
    const router = useRouter();
    const hc = (e) => {
        e.preventDefault();
        rudderStackTrack(action, {value: href});
        router.push(href);
    };

    return <Link href={href} onClick={hc}>
        {children}
    </Link>;
};
